function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("aUZKu", function(module, exports) {
    $parcel$export(module.exports, "BrowserStorageControlsInit", ()=>$5fb24b373880ec53$export$1e5524c82dfa4c29);
    var $5uXOq = parcelRequire("5uXOq");
    var $cj467;
    const $5fb24b373880ec53$export$1e5524c82dfa4c29 = ()=>{
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("cj467")).initializeControls)({
                product: 'Jira'
            });
        }, []);
        return null;
    };
});
parcelRegister("cj467", function(module, exports) {
    $parcel$export(module.exports, "initializeControls", ()=>$8f5a701cddd6810f$export$919040c32a62c7db);
    var $aGNyr;
    var $3zdAw;
    var $cala7;
    var $ebDg1;
    var $9eaC8;
    parcelRequire("e5M61");
    var $d7IKg;
    var $gUsfR;
    var $lqqHs;
    const $8f5a701cddd6810f$export$919040c32a62c7db = async (args = {})=>{
        try {
            (0, (0, parcelRequire("9eaC8")).initializeGlobalState)(args);
            if ((0, (0, parcelRequire("3zdAw")).isSSR)()) return;
            const isBSCFlagEnabled = await (0, (0, parcelRequire("ebDg1")).pollForBrowserControlsFlag)();
            if (!isBSCFlagEnabled) return;
            const analyticsWebClientInstance = (0, (0, parcelRequire("aGNyr")).getAnalyticsClient)();
            const isAnalyticsInitialized = !!analyticsWebClientInstance;
            if (!isAnalyticsInitialized) throw new Error(`Failed to initialize AnalyticsWebClient. Analytics logging will not be set for native method overrides.`);
            await (0, (0, parcelRequire("gUsfR")).createDocumentCookiePassthrough)();
            const isWebStorageControlsEnabled = (0, (0, parcelRequire("9eaC8")).getBscGlobalState)().webStorageEnabled;
            if (!isWebStorageControlsEnabled) return;
            await (0, (0, parcelRequire("lqqHs")).createWebStoragePassthrough)((0, (0, parcelRequire("d7IKg")).StorageType).LocalStorage);
            await (0, (0, parcelRequire("lqqHs")).createWebStoragePassthrough)((0, (0, parcelRequire("d7IKg")).StorageType).SessionStorage);
        } catch (e) {
            (0, (0, parcelRequire("cala7")).Logger).errorWithOperationalEvent({
                action: 'initializeControlsError',
                message: `Failed to initialize browser storage controls. ${e.message || ''}`
            });
        }
    };
});
parcelRegister("ebDg1", function(module, exports) {
    $parcel$export(module.exports, "pollForBrowserControlsFlag", ()=>$a5408b7544408c99$export$cc1c284801c32a43);
    var $VSDnB;
    const $a5408b7544408c99$var$TIME_IN_MS = 1000;
    const $a5408b7544408c99$var$MAX_WAIT_TIME = 300 * $a5408b7544408c99$var$TIME_IN_MS;
    const $a5408b7544408c99$var$INITIAL_WAIT_TIME = 2 * $a5408b7544408c99$var$TIME_IN_MS;
    const $a5408b7544408c99$export$cc1c284801c32a43 = async (waitTime = $a5408b7544408c99$var$INITIAL_WAIT_TIME, totalElapsedTime = 0)=>{
        return $a5408b7544408c99$var$pollForFeatureFlag('platform.moonjelly.browser-storage-controls', waitTime, totalElapsedTime, $a5408b7544408c99$export$cc1c284801c32a43);
    };
    const $a5408b7544408c99$var$pollForFeatureFlag = (featureFlag, waitTime = $a5408b7544408c99$var$INITIAL_WAIT_TIME, totalElapsedTime = 0, pollingFuncReference)=>{
        const shouldCancelPolling = totalElapsedTime > $a5408b7544408c99$var$MAX_WAIT_TIME;
        if (shouldCancelPolling) return Promise.resolve(false);
        if (!(0, (0, parcelRequire("VSDnB")).fg)(featureFlag)) {
            const newWaitTime = waitTime * 2;
            const cappedWaitTime = Math.min(newWaitTime, $a5408b7544408c99$var$MAX_WAIT_TIME);
            return new Promise((resolve)=>{
                setTimeout(async ()=>{
                    const updatedElapsedTime = totalElapsedTime + cappedWaitTime;
                    const newFlagState = await pollingFuncReference(cappedWaitTime, updatedElapsedTime);
                    resolve(newFlagState);
                }, cappedWaitTime);
            });
        }
        return Promise.resolve(true);
    };
});
parcelRegister("e5M61", function(module, exports) {
    $parcel$export(module.exports, "findStorageTarget", ()=>$a426d7334c0bae09$export$14921bfc334334c0);
    $parcel$export(module.exports, "StorageType", ()=>(parcelRequire("d7IKg")).StorageType);
    var $eHiP8 = parcelRequire("eHiP8");
    var $9eaC8;
    var $3zdAw;
    var $cala7;
    var $iG1qD;
    var $gJQVy;
    var $d7IKg;
    var $jYVP9;
    var $lHwGK;
    var $cYsjN;
    var $a426d7334c0bae09$var$_window, $a426d7334c0bae09$var$_window2;
    class $a426d7334c0bae09$export$8e4a3cf07a10930b {
        constructor(storage, storageType){
            (0, $eHiP8.default)(this, "isAvailable", false);
            (0, $eHiP8.default)(this, "checkIfSetByPackage", async ({ itemKey: itemKey, isSetCallback: isSetCallback = ()=>{}, isNotSetCallback: isNotSetCallback = ()=>{} })=>{
                try {
                    const record = await (0, (0, parcelRequire("gJQVy")).BSCIndexedDB).getRecord(itemKey);
                    if (record) {
                        isSetCallback();
                        return true;
                    } else {
                        isNotSetCallback();
                        return false;
                    }
                } catch (e) {
                    (0, (0, parcelRequire("cala7")).Logger).errorWithOperationalEvent({
                        action: 'usedCheckIfSetByPackageError',
                        message: `IDB lookup failed to check if item was set by package. ${e.message || ''}`,
                        attributes: {
                            itemKey: itemKey
                        }
                    });
                    isNotSetCallback();
                    return false;
                }
            });
            this.storage = storage;
            this.storageType = storageType;
            this.isAvailable = this.isStorageAvailable();
        }
        get isWebStorageEnabled() {
            if ((0, (0, parcelRequire("9eaC8")).getBscGlobalState)().webStorageEnabled) return true;
            (0, (0, parcelRequire("cala7")).Logger).warn('WebStorage config is disabled, cannot proceed.');
            return false;
        }
        getItem(key) {
            if (!this.isWebStorageEnabled) return null;
            if (!this.isAvailable) {
                (0, (0, parcelRequire("cala7")).Logger).warn(`${this.storageType} is unavailable. Failed to get item.`);
                return null;
            }
            const retrievedItem = (0, (0, parcelRequire("jYVP9")).getStorageItem)(key, this.storageType, this.storage);
            return retrievedItem;
        }
        async setItem(key, value) {
            if (!this.isWebStorageEnabled) return;
            if (!this.isAvailable) {
                (0, (0, parcelRequire("cala7")).Logger).warn(`${this.storageType} is unavailable. Failed to set item.`);
                return;
            }
            const itemSetStatus = await (0, (0, parcelRequire("lHwGK")).setStorageItem)(key, value, this.storageType, this.storage);
            (0, (0, parcelRequire("cala7")).Logger).warn(`${itemSetStatus === (0, (0, parcelRequire("iG1qD")).Status).SUCCESS ? 'Successfully' : 'Failed to'} set item ${key} with value ${value}`);
        }
        setStrictlyNecessaryItem(key, value) {
            if (!this.isWebStorageEnabled) return;
            if (!this.isAvailable) {
                (0, (0, parcelRequire("cala7")).Logger).warn(`${this.storageType} is unavailable. Failed to set strictly necessary item.`);
                return;
            }
            const itemSetStatus = (0, (0, parcelRequire("cYsjN")).setStrictlyNecessaryStorageItem)(key, value, this.storageType, this.storage);
            (0, (0, parcelRequire("cala7")).Logger).warn(`${itemSetStatus === (0, (0, parcelRequire("iG1qD")).Status).SUCCESS ? 'Successfully' : 'Failed to'} set strictly necessary item ${key} with value ${value}`);
        }
        removeItem(key) {
            if (!this.isWebStorageEnabled) return;
            if (!this.isAvailable) {
                (0, (0, parcelRequire("cala7")).Logger).warn(`${this.storageType} is unavailable. Failed to remove item.`);
                return;
            }
            this.storage.removeItem(key);
        }
        key(index) {
            if (!this.isWebStorageEnabled) return null;
            if (!this.isAvailable) return null;
            return this.storage.key(index);
        }
        length() {
            if (!this.isWebStorageEnabled) return 0;
            if (!this.isAvailable) return 0;
            return this.storage.length;
        }
        clear() {
            if (!this.isWebStorageEnabled) return;
            if (!this.isAvailable) return;
            this.storage.clear();
        }
        isStorageAvailable() {
            if ((0, (0, parcelRequire("3zdAw")).isSSR)()) return false;
            try {
                const x = '__storage_test__';
                this.storage.setItem(x, x);
                this.storage.removeItem(x);
                return true;
            } catch (e) {
                return e instanceof DOMException && (e.code === 22 || e.code === 1014 || e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && this.storage && this.storage.length !== 0;
            }
        }
    }
    const $a426d7334c0bae09$export$c8cc3ffd3f2c1d2f = new $a426d7334c0bae09$export$8e4a3cf07a10930b(($a426d7334c0bae09$var$_window = window) === null || $a426d7334c0bae09$var$_window === void 0 ? void 0 : $a426d7334c0bae09$var$_window.localStorage, (0, (0, parcelRequire("d7IKg")).StorageType).LocalStorage);
    const $a426d7334c0bae09$export$edbae459bdf957a5 = new $a426d7334c0bae09$export$8e4a3cf07a10930b(($a426d7334c0bae09$var$_window2 = window) === null || $a426d7334c0bae09$var$_window2 === void 0 ? void 0 : $a426d7334c0bae09$var$_window2.sessionStorage, (0, (0, parcelRequire("d7IKg")).StorageType).SessionStorage);
    const $a426d7334c0bae09$export$14921bfc334334c0 = (type)=>{
        return ({
            [(0, (0, parcelRequire("d7IKg")).StorageType).LocalStorage]: $a426d7334c0bae09$export$c8cc3ffd3f2c1d2f,
            [(0, (0, parcelRequire("d7IKg")).StorageType).SessionStorage]: $a426d7334c0bae09$export$edbae459bdf957a5
        })[type];
    };
});
parcelRegister("gJQVy", function(module, exports) {
    $parcel$export(module.exports, "BSCIndexedDB", ()=>$c2f9e78b40bd61cb$export$36328b3bcbe4623a);
    var $eHiP8 = parcelRequire("eHiP8");
    var $3zdAw;
    var $cala7;
    class $c2f9e78b40bd61cb$export$fde2a4e0e57f47e {
        constructor(dbName, storeName){
            (0, $eHiP8.default)(this, "db", null);
            (0, $eHiP8.default)(this, "isBooted", false);
            (0, $eHiP8.default)(this, "isAvailable", false);
            (0, $eHiP8.default)(this, "onConnectionErrorHandler", (reject)=>(event)=>{
                    (0, (0, parcelRequire("cala7")).Logger).warn('Error opening database.');
                    reject(event);
                });
            (0, $eHiP8.default)(this, "onConnectionSuccessHandler", (connection, resolve)=>(event)=>{
                    this.db = connection.result;
                    resolve();
                });
            (0, $eHiP8.default)(this, "onConnectionUpgradeNeededHandler", (request)=>(event)=>{
                    this.db = request.result;
                    this.db.createObjectStore(this.storeName, {
                        keyPath: 'id'
                    });
                });
            (0, $eHiP8.default)(this, "onGetRecordErrorHandler", (reject)=>()=>{
                    const getErrorMessage = `Failed to perform a get transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                    (0, (0, parcelRequire("cala7")).Logger).warn(getErrorMessage);
                    reject(getErrorMessage);
                });
            (0, $eHiP8.default)(this, "onGetRecordSuccessHandler", (getRequest, resolve)=>()=>{
                    resolve(getRequest.result);
                });
            (0, $eHiP8.default)(this, "onSetRecordErrorHandler", (reject)=>()=>{
                    const errorMessage = `Failed to perform a set transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                    (0, (0, parcelRequire("cala7")).Logger).warn(errorMessage);
                    reject(errorMessage);
                });
            (0, $eHiP8.default)(this, "onSetRecordSuccessHandler", (resolve)=>()=>{
                    resolve();
                });
            this.dbName = dbName;
            this.storeName = storeName;
            this.isAvailable = this.getIsDBAvailable();
            this.isBooted = false;
            this.bootUpPromiseCache = null;
        }
        async boot() {
            if (!this.isAvailable) {
                (0, (0, parcelRequire("cala7")).Logger).warn('IndexedDB is not available');
                return;
            }
            if (this.isBooted) return;
            if (!this.bootUpPromiseCache) {
                this.bootUpPromiseCache = this.openDB();
                try {
                    await this.bootUpPromiseCache;
                    this.isBooted = true;
                } catch (e) {
                    this.isBooted = false;
                    (0, (0, parcelRequire("cala7")).Logger).warn('Error booting up IndexedDB.');
                    throw e;
                }
            }
        }
        getIsDBAvailable() {
            return !(0, (0, parcelRequire("3zdAw")).isSSR)() && !!window.indexedDB;
        }
        async openDB() {
            return new Promise((resolve, reject)=>{
                let request = indexedDB.open(this.dbName, 1);
                request.onerror = this.onConnectionErrorHandler(reject);
                request.onsuccess = this.onConnectionSuccessHandler(request, resolve);
                request.onupgradeneeded = this.onConnectionUpgradeNeededHandler(request);
            });
        }
        async getRecord(recordKey) {
            try {
                if (!this.isBooted) await this.boot();
                if (!this.db) throw new Error('Database is not opened');
                let fetchTransaction = this.db.transaction([
                    this.storeName
                ]);
                let recordStore = fetchTransaction.objectStore(this.storeName);
                const fetchedRecord = new Promise((resolve, reject)=>{
                    let request = recordStore.get(recordKey);
                    request.onerror = this.onGetRecordErrorHandler(reject);
                    request.onsuccess = this.onGetRecordSuccessHandler(request, resolve);
                });
                return fetchedRecord;
            } catch (e) {
                (0, (0, parcelRequire("cala7")).Logger).error(`Error fetching record from database. ${e.message || ''}`);
                throw e;
            }
        }
        async setRecord(recordKey) {
            try {
                if (!this.isBooted) await this.boot();
                if (!this.db) throw new Error('Database is not opened');
                const setRecord = new Promise((resolve, reject)=>{
                    let setTransaction = this.db.transaction([
                        this.storeName
                    ], 'readwrite');
                    let objectStore = setTransaction.objectStore(this.storeName);
                    let request = objectStore.add('SET-BY-PACKAGE', recordKey);
                    request.onerror = this.onSetRecordErrorHandler(reject);
                    request.onsuccess = this.onSetRecordSuccessHandler(resolve);
                });
                return setRecord;
            } catch (e) {
                (0, (0, parcelRequire("cala7")).Logger).warn(`Error setting record in database. ${e.message || ''}`);
                throw e;
            }
        }
    }
    const $c2f9e78b40bd61cb$export$36328b3bcbe4623a = new $c2f9e78b40bd61cb$export$fde2a4e0e57f47e('BSCIndexedDB', 'InternalStorageKeys');
});
parcelRegister("d7IKg", function(module, exports) {
    $parcel$export(module.exports, "StorageType", ()=>$98dea346fcd7973a$export$d5f3ec63cad061d9);
    let $98dea346fcd7973a$export$d5f3ec63cad061d9 = function(StorageType) {
        StorageType["LocalStorage"] = "localStorage";
        StorageType["SessionStorage"] = "sessionStorage";
        return StorageType;
    }({});
});
parcelRegister("jYVP9", function(module, exports) {
    $parcel$export(module.exports, "getStorageItem", ()=>$e8c0798d14f557ed$export$e612bb1301d659de);
    var $VSDnB;
    var $aGNyr;
    var $cala7;
    const $e8c0798d14f557ed$export$e612bb1301d659de = (itemKey, storageType, browserStorage)=>{
        const eventAttributes = {
            itemKey: itemKey,
            storageType: storageType
        };
        try {
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform.moonjelly.browser-storage-controls')) (0, (0, parcelRequire("aGNyr")).sendPackageOperationalEvent)({
                action: 'usedAtlBrowserStorageGetItem',
                attributes: eventAttributes
            });
            return browserStorage.getItem(itemKey);
        } catch (e) {
            (0, (0, parcelRequire("cala7")).Logger).errorWithOperationalEvent({
                action: 'usedAtlBrowserStorageGetItemError',
                attributes: eventAttributes,
                message: `Failed to get ${storageType} item. ${e.message || ''}`
            });
            return null;
        }
    };
});
parcelRegister("lHwGK", function(module, exports) {
    $parcel$export(module.exports, "setStorageItem", ()=>$fcc6f85b8e96db81$export$5ee8760f703d9d62);
    var $VSDnB;
    var $aGNyr;
    var $4o4nv;
    var $cala7;
    var $gJQVy;
    var $iG1qD;
    const $fcc6f85b8e96db81$export$5ee8760f703d9d62 = async (itemKey, value, storageType, browserStorage)=>{
        if (!(0, (0, parcelRequire("VSDnB")).fg)('platform.moonjelly.browser-storage-controls')) {
            const eventAttributes = {
                wasRejected: false,
                itemKey: itemKey,
                storageType: storageType
            };
            try {
                browserStorage.setItem(itemKey, value);
                return (0, (0, parcelRequire("iG1qD")).Status).SUCCESS;
            } catch (e) {
                (0, (0, parcelRequire("cala7")).Logger).errorWithOperationalEvent({
                    action: 'usedAtlBrowserStorageSetItemError',
                    attributes: eventAttributes,
                    message: `Failed to set ${storageType} item. ${e.message || ''}`
                });
                return (0, (0, parcelRequire("iG1qD")).Status).FAILED;
            }
        }
        const shouldSetItem = await (0, (0, parcelRequire("4o4nv")).isProcessingAllowedByPreferences)({
            itemKey: itemKey
        });
        const eventAttributes = {
            wasRejected: !shouldSetItem,
            itemKey: itemKey,
            storageType: storageType
        };
        try {
            (0, (0, parcelRequire("aGNyr")).sendPackageOperationalEvent)({
                action: 'usedAtlBrowserStorageSetItem',
                attributes: eventAttributes
            });
            if (shouldSetItem) {
                await (0, (0, parcelRequire("gJQVy")).BSCIndexedDB).setRecord(itemKey);
                browserStorage.setItem(itemKey, value);
                return (0, (0, parcelRequire("iG1qD")).Status).SUCCESS;
            } else return (0, (0, parcelRequire("iG1qD")).Status).BLOCKED;
        } catch (e) {
            (0, (0, parcelRequire("cala7")).Logger).errorWithOperationalEvent({
                action: 'usedAtlBrowserStorageSetItemError',
                attributes: eventAttributes,
                message: `Failed to set ${storageType} item. ${e.message || ''}`
            });
            return (0, (0, parcelRequire("iG1qD")).Status).BLOCKED;
        }
    };
});
parcelRegister("4o4nv", function(module, exports) {
    $parcel$export(module.exports, "isProcessingAllowedByPreferences", ()=>$331cccbaa6fe64fc$export$e7a3dca206fec6e2);
    var $8yV7s;
    var $iG1qD;
    var $8Ow66;
    const $331cccbaa6fe64fc$export$2c141b1c00f3e482 = (itemKey, { startsWith: startsWith })=>{
        let currentStep = startsWith;
        let position = 0;
        while(position < itemKey.length){
            const currentStepValue = currentStep[itemKey[position]];
            if (currentStepValue === undefined) return null;
            if (typeof currentStepValue === 'number') return currentStepValue;
            currentStep = currentStepValue;
            position++;
        }
        return null;
    };
    const $331cccbaa6fe64fc$export$69d5b68d01f4a366 = (itemKey, storageControlsData, cachedKeysDataProperty)=>{
        let itemCategoryNumber = null;
        const { categories: categories, patterns: patterns } = storageControlsData;
        let keys = storageControlsData[cachedKeysDataProperty];
        if (itemKey in Object(keys)) itemCategoryNumber = keys[itemKey];
        else itemCategoryNumber = $331cccbaa6fe64fc$export$2c141b1c00f3e482(itemKey, patterns);
        const numToCategoryMap = {
            [categories.STRICTLY_NECESSARY]: (0, (0, parcelRequire("iG1qD")).PreferenceCategory).StrictlyNecessary,
            [categories.FUNCTIONAL]: (0, (0, parcelRequire("iG1qD")).PreferenceCategory).Functional,
            [categories.ANALYTICS]: (0, (0, parcelRequire("iG1qD")).PreferenceCategory).Analytics,
            [categories.MARKETING]: (0, (0, parcelRequire("iG1qD")).PreferenceCategory).Marketing,
            [categories.UNKNOWN]: (0, (0, parcelRequire("iG1qD")).PreferenceCategory).Unknown
        };
        return itemCategoryNumber !== null ? numToCategoryMap[itemCategoryNumber] : null;
    };
    const $331cccbaa6fe64fc$export$ec8ce5237293e4a4 = async (itemKey, cachedKeysDataProperty)=>{
        const storageControlsData = await (0, (0, parcelRequire("8Ow66")).loadStorageControlsData)();
        if (!storageControlsData) return null;
        else return $331cccbaa6fe64fc$export$69d5b68d01f4a366(itemKey, storageControlsData, cachedKeysDataProperty);
    };
    const $331cccbaa6fe64fc$export$e7a3dca206fec6e2 = async ({ itemKey: itemKey, allowedCallback: allowedCallback = ()=>{}, blockedCallback: blockedCallback = ()=>{}, cachedKeysDataProperty: cachedKeysDataProperty = (0, (0, parcelRequire("iG1qD")).CachedKeysDataProperty).Cookies })=>{
        let shouldProcessItem;
        const shouldSkip = cachedKeysDataProperty === (0, (0, parcelRequire("iG1qD")).CachedKeysDataProperty).LocalStorage || cachedKeysDataProperty === (0, (0, parcelRequire("iG1qD")).CachedKeysDataProperty).SessionStorage;
        const itemCategory = shouldSkip ? (0, (0, parcelRequire("iG1qD")).PreferenceCategory).StrictlyNecessary : await $331cccbaa6fe64fc$export$ec8ce5237293e4a4(itemKey, cachedKeysDataProperty);
        if (itemCategory === (0, (0, parcelRequire("iG1qD")).PreferenceCategory).StrictlyNecessary) shouldProcessItem = true;
        else {
            const preferences = await (0, (0, parcelRequire("8yV7s")).getPreferences)();
            let hasPreferencesForCategory = false;
            if (!!preferences) {
                if (!!itemCategory) hasPreferencesForCategory = preferences[itemCategory];
            }
            shouldProcessItem = hasPreferencesForCategory;
        }
        if (shouldProcessItem) allowedCallback === null || allowedCallback === void 0 || allowedCallback();
        else blockedCallback === null || blockedCallback === void 0 || blockedCallback({
            itemHasCategory: itemCategory != null
        });
        return shouldProcessItem;
    };
});
parcelRegister("8yV7s", function(module, exports) {
    $parcel$export(module.exports, "getPreferences", ()=>$63bdce623eb86acc$export$1de6a888ae076ff8);
    var $VSDnB;
    var $e7OnS;
    var $jlKyx;
    var $eMLDH;
    var $4qYnX;
    async function $63bdce623eb86acc$export$1de6a888ae076ff8() {
        if (!(0, (0, parcelRequire("VSDnB")).fg)('platform.moonjelly.browser-storage-controls-v2')) {
            const packedPrefs = (0, (0, parcelRequire("eMLDH")).getCookie)((0, (0, parcelRequire("e7OnS")).LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
            if (!packedPrefs) return undefined;
            return (0, (0, parcelRequire("4qYnX")).unpackUserPreferencesCookie)(packedPrefs);
        }
        let packedLocalPrefs = (0, (0, parcelRequire("eMLDH")).getCookie)((0, (0, parcelRequire("e7OnS")).ATLASSIAN_CONSENT_COOKIE_KEY));
        if (!packedLocalPrefs) {
            const consentToken = await (0, (0, parcelRequire("jlKyx")).getConsentToken)();
            return consentToken ? (0, (0, parcelRequire("4qYnX")).unpackUserPreferencesCookie)(consentToken) : undefined;
        }
        return (0, (0, parcelRequire("4qYnX")).unpackUserPreferencesCookie)(packedLocalPrefs);
    }
});
parcelRegister("jlKyx", function(module, exports) {
    $parcel$export(module.exports, "getConsentToken", ()=>$e1641792109b47e6$export$f1b8f2ca713fca08);
    var $e7OnS;
    var $eMLDH;
    var $hqdIW;
    var $dKrpM;
    var $lxnql;
    const $e1641792109b47e6$export$f1b8f2ca713fca08 = async ()=>{
        const fallbackConsentToken = (0, (0, parcelRequire("eMLDH")).getCookie)((0, (0, parcelRequire("e7OnS")).ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        const consentData = await (0, (0, parcelRequire("lxnql")).getValidConsentData)(fallbackConsentToken);
        if (consentData) {
            const { consentToken: consentToken, consentTimestamp: consentTimestamp } = consentData;
            const potentiallyOverriddenConsentToken = (0, (0, parcelRequire("hqdIW")).overrideConsentTokenForLiveTesting)(consentToken);
            const testingConsentOverride = (0, (0, parcelRequire("eMLDH")).getCookie)((0, (0, parcelRequire("e7OnS")).TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
            const hasTestingConsents = !!(testingConsentOverride || testingConsentOverride === '');
            if (hasTestingConsents) {
                (0, (0, parcelRequire("dKrpM")).setShouldShowBannerCookie)(potentiallyOverriddenConsentToken);
                (0, (0, parcelRequire("dKrpM")).setConsentTokenCookie)(potentiallyOverriddenConsentToken);
                return potentiallyOverriddenConsentToken === '' ? undefined : potentiallyOverriddenConsentToken;
            }
            (0, (0, parcelRequire("dKrpM")).setRequiredConsentCookies)(potentiallyOverriddenConsentToken, consentTimestamp);
            return consentToken;
        }
        return undefined;
    };
});
parcelRegister("hqdIW", function(module, exports) {
    $parcel$export(module.exports, "overrideConsentTokenForLiveTesting", ()=>$caef82a1e737c7f7$export$b5282052fc15e1ae);
    var $e7OnS;
    var $eMLDH;
    const $caef82a1e737c7f7$export$b5282052fc15e1ae = (genuineConsentToken)=>{
        const tokenOverride = (0, (0, parcelRequire("eMLDH")).getCookie)((0, (0, parcelRequire("e7OnS")).TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
        return tokenOverride || genuineConsentToken;
    };
});
parcelRegister("dKrpM", function(module, exports) {
    $parcel$export(module.exports, "setConsentTokenCookie", ()=>$a024d63fdab5034c$export$8e560d0760f733a2);
    $parcel$export(module.exports, "setConsentTokenFallbackCookie", ()=>$a024d63fdab5034c$export$133cd762b0f705a2);
    $parcel$export(module.exports, "setShouldShowBannerCookie", ()=>$a024d63fdab5034c$export$99ecece88c58d938);
    $parcel$export(module.exports, "setRequiredConsentCookies", ()=>$a024d63fdab5034c$export$b3365240280cb3c3);
    var $1Vlui;
    var $e7OnS;
    var $fIz84;
    var $GjM2o;
    const $a024d63fdab5034c$export$8e560d0760f733a2 = (consentToken)=>{
        const inTenMinutes = new Date();
        inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
        (0, (0, parcelRequire("GjM2o")).setStrictlyNecessaryCookie)((0, (0, parcelRequire("e7OnS")).ATLASSIAN_CONSENT_COOKIE_KEY), consentToken, {
            expires: inTenMinutes,
            path: '/'
        });
    };
    const $a024d63fdab5034c$export$133cd762b0f705a2 = (consentToken)=>{
        const inOneYear = new Date();
        inOneYear.setFullYear(inOneYear.getFullYear() + 1);
        (0, (0, parcelRequire("GjM2o")).setStrictlyNecessaryCookie)((0, (0, parcelRequire("e7OnS")).ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY), consentToken, {
            expires: inOneYear,
            path: '/'
        });
    };
    const $a024d63fdab5034c$export$99ecece88c58d938 = (consentToken, consentTimestamp)=>{
        const bannerVisibility = (0, (0, parcelRequire("fIz84")).getBannerVisibility)({
            consentToken: consentToken,
            consentTimestamp: consentTimestamp
        });
        const shouldShowBanner = (0, (0, parcelRequire("1Vlui")).getBitValueFromBool)(!!bannerVisibility);
        const inTenMinutes = new Date();
        inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
        (0, (0, parcelRequire("GjM2o")).setStrictlyNecessaryCookie)((0, (0, parcelRequire("e7OnS")).ATLASSIAN_SHOW_BANNER_COOKIE_KEY), shouldShowBanner, {
            expires: inTenMinutes,
            path: '/'
        });
    };
    const $a024d63fdab5034c$export$b3365240280cb3c3 = (consentToken, consentTimestamps)=>{
        $a024d63fdab5034c$export$8e560d0760f733a2(consentToken);
        $a024d63fdab5034c$export$99ecece88c58d938(consentToken, consentTimestamps);
    };
});
parcelRegister("GjM2o", function(module, exports) {
    $parcel$export(module.exports, "setStrictlyNecessaryCookie", ()=>$07f3430601091fbe$export$93509ff9a62ee022);
    var $eYli8 = parcelRequire("eYli8");
    var $VSDnB;
    var $aGNyr;
    var $cala7;
    const $07f3430601091fbe$export$93509ff9a62ee022 = (key, value, attributes)=>{
        try {
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform.moonjelly.browser-storage-controls')) (0, (0, parcelRequire("aGNyr")).sendPackageOperationalEvent)({
                action: 'usedSetStrictlyNecessaryCookie',
                attributes: {
                    cookieKey: key
                }
            });
            (0, ($parcel$interopDefault($eYli8))).set(key, value, {
                ...attributes,
                'atl-set-cookie': true
            });
        } catch (e) {
            (0, (0, parcelRequire("cala7")).Logger).errorWithOperationalEvent({
                action: 'usedSetStrictlyNecessaryCookieError',
                attributes: {
                    cookieKey: key
                },
                message: `Failed to use set strictly necessary cookie. ${e.message || ''}`
            });
        }
    };
});
parcelRegister("lxnql", function(module, exports) {
    $parcel$export(module.exports, "getValidConsentData", ()=>$faded98915bfbca5$export$c515de1cc9cebc71);
    var $j78Eu;
    var $4qYnX;
    const $faded98915bfbca5$export$c515de1cc9cebc71 = async (fallbackConsentToken)=>{
        const consentData = await (0, (0, parcelRequire("j78Eu")).fetchConsentPreferences)();
        let { consentToken: consentToken, consentTimestamp: consentTimestamp, consentHubInaccessible: consentHubInaccessible } = consentData;
        let { isValid: isValid } = (0, (0, parcelRequire("4qYnX")).checkTokenVersionValidity)(consentToken);
        if (isValid && consentHubInaccessible) {
            if (fallbackConsentToken) consentToken = fallbackConsentToken;
            else consentToken = `${consentToken.slice(0, 8)}1111`;
        }
        return isValid ? {
            consentToken: consentToken,
            consentTimestamp: consentTimestamp
        } : undefined;
    };
});
parcelRegister("cYsjN", function(module, exports) {
    $parcel$export(module.exports, "setStrictlyNecessaryStorageItem", ()=>$97210e0f7639f244$export$f1b0c189562aa9fd);
    var $VSDnB;
    var $aGNyr;
    var $cala7;
    var $iG1qD;
    var $gJQVy;
    const $97210e0f7639f244$export$f1b0c189562aa9fd = (itemKey, value, storageType, browserStorage)=>{
        const eventAttributes = {
            itemKey: itemKey,
            storageType: storageType
        };
        try {
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform.moonjelly.browser-storage-controls')) {
                (0, (0, parcelRequire("aGNyr")).sendPackageOperationalEvent)({
                    action: 'usedAtlBrowserStorageSetStrictlyNecessaryItem',
                    attributes: eventAttributes
                });
                (0, (0, parcelRequire("gJQVy")).BSCIndexedDB).setRecord(itemKey).then(()=>{}).catch((e)=>{
                    throw new Error(e.message || '');
                });
            }
            browserStorage.setItem(itemKey, value);
            return (0, (0, parcelRequire("iG1qD")).Status).SUCCESS;
        } catch (e) {
            (0, (0, parcelRequire("cala7")).Logger).errorWithOperationalEvent({
                action: 'usedAtlBrowserStorageSetStrictlyNecessaryItemError',
                attributes: eventAttributes,
                message: `Failed to set strictly necessary ${storageType} item. ${e.message || ''}`
            });
            return (0, (0, parcelRequire("iG1qD")).Status).FAILED;
        }
    };
});
parcelRegister("gUsfR", function(module, exports) {
    $parcel$export(module.exports, "createDocumentCookiePassthrough", ()=>$032d49784b64bf15$export$45a5573b04db016c);
    var $cala7;
    var $bXpH2;
    const $032d49784b64bf15$export$45a5573b04db016c = async ()=>{
        const documentCookieProperty = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie');
        const originalSetter = documentCookieProperty === null || documentCookieProperty === void 0 ? void 0 : documentCookieProperty.set;
        const originalGetter = documentCookieProperty === null || documentCookieProperty === void 0 ? void 0 : documentCookieProperty.get;
        if (!originalSetter || !originalGetter) {
            (0, (0, parcelRequire("cala7")).Logger).warn('No document.cookie capabilities found');
            return;
        }
        Object.defineProperty(document, 'cookie', {
            get: originalGetter,
            set: (0, (0, parcelRequire("bXpH2")).getSetCookieOverride)(originalSetter),
            configurable: true
        });
    };
});
parcelRegister("bXpH2", function(module, exports) {
    $parcel$export(module.exports, "getSetCookieOverride", ()=>$8b492289a37b55a1$export$b7364c41ddbfdb0a);
    var $VSDnB;
    var $aGNyr;
    var $4o4nv;
    var $cala7;
    var $iG1qD;
    const $8b492289a37b55a1$export$b7364c41ddbfdb0a = (originalSetter)=>(originalCookieValue)=>{
            const cookieSetByPackage = originalCookieValue.includes('atl-set-cookie');
            if (cookieSetByPackage) try {
                return originalSetter.apply(document, [
                    originalCookieValue
                ]);
            } catch (e) {
                (0, (0, parcelRequire("cala7")).Logger).errorWithOperationalEvent({
                    action: 'usedDocumentCookieError',
                    message: `document.cookie setter failed to set cookie set by package. ${e.message || ''}`,
                    attributes: {
                        outsidePackage: false
                    }
                });
            }
            try {
                const sanitizedCookieKey = originalCookieValue.slice(0, originalCookieValue.indexOf('=')) || '';
                (0, (0, parcelRequire("aGNyr")).sendPackageOperationalEvent)({
                    action: 'usedDocumentCookie',
                    attributes: {
                        cookieKey: sanitizedCookieKey,
                        outsidePackage: !cookieSetByPackage
                    }
                });
                try {
                    (0, (0, parcelRequire("4o4nv")).isProcessingAllowedByPreferences)({
                        itemKey: sanitizedCookieKey,
                        allowedCallback: ()=>{
                            return originalSetter.apply(document, [
                                originalCookieValue
                            ]);
                        },
                        blockedCallback: ({ itemHasCategory: itemHasCategory })=>{
                            if ((0, (0, parcelRequire("VSDnB")).fg)('platform.moonjelly.block-unknown-cookies')) return;
                            else {
                                if (!itemHasCategory) return originalSetter.apply(document, [
                                    originalCookieValue
                                ]);
                                else return;
                            }
                        },
                        cachedKeysDataProperty: (0, (0, parcelRequire("iG1qD")).CachedKeysDataProperty).Cookies
                    });
                } catch (e) {
                    (0, (0, parcelRequire("cala7")).Logger).errorWithOperationalEvent({
                        action: 'usedDocumentCookieError',
                        message: `Failed to set cookie. ${e.message || ''}`,
                        attributes: {
                            cookieKey: sanitizedCookieKey
                        }
                    });
                }
            } catch (e) {
                (0, (0, parcelRequire("cala7")).Logger).errorWithOperationalEvent({
                    action: 'usedDocumentCookieError',
                    message: `Failed to send document.cookie setter event. ${e.message || ''}`
                });
            }
        };
});
parcelRegister("lqqHs", function(module, exports) {
    $parcel$export(module.exports, "createWebStoragePassthrough", ()=>$f990bcbc77ef86a5$export$619fe705922e5d61);
    var $cala7;
    var $gJQVy;
    var $e5M61;
    var $cgnsz;
    const $f990bcbc77ef86a5$export$619fe705922e5d61 = async (storageType)=>{
        const bscStorage = (0, (0, parcelRequire("e5M61")).findStorageTarget)(storageType);
        if (!bscStorage.isAvailable) {
            (0, (0, parcelRequire("cala7")).Logger).warn(`No ${storageType} capabilities found`);
            return;
        }
        if (!(0, (0, parcelRequire("gJQVy")).BSCIndexedDB).isAvailable) {
            (0, (0, parcelRequire("cala7")).Logger).warn('IndexedDB is not available');
            return;
        }
        if (!(0, (0, parcelRequire("gJQVy")).BSCIndexedDB).isBooted) await (0, (0, parcelRequire("gJQVy")).BSCIndexedDB).boot();
        const originalSetItem = bscStorage.storage.setItem;
        const overriddenStorageClass = {
            clear: bscStorage.clear.bind(bscStorage),
            key: bscStorage.key.bind(bscStorage),
            length: bscStorage.length.bind(bscStorage),
            removeItem: bscStorage.removeItem.bind(bscStorage),
            getItem: bscStorage.getItem.bind(bscStorage),
            setItem: (0, (0, parcelRequire("cgnsz")).setItemOverride)(bscStorage, originalSetItem, storageType)
        };
        Object.defineProperty(window, storageType, {
            value: overriddenStorageClass,
            writable: true,
            configurable: true
        });
    };
});
parcelRegister("cgnsz", function(module, exports) {
    $parcel$export(module.exports, "setItemOverride", ()=>$8ed92d4497fd7034$export$b4469df6294ea6aa);
    var $VSDnB;
    var $aGNyr;
    var $4o4nv;
    var $cala7;
    parcelRequire("e5M61");
    var $d7IKg;
    var $iG1qD;
    const $8ed92d4497fd7034$export$b4469df6294ea6aa = (bscStorage, originalSetItem, storageType)=>(originalItemKey, originalItemValue)=>{
            const storageContext = bscStorage.storage;
            let itemSetByPackage = false;
            bscStorage.checkIfSetByPackage({
                itemKey: originalItemKey,
                isSetCallback: ()=>{
                    itemSetByPackage = true;
                },
                isNotSetCallback: ()=>{
                    itemSetByPackage = false;
                }
            });
            if (itemSetByPackage) try {
                return originalSetItem.apply(storageContext, [
                    originalItemKey,
                    originalItemValue
                ]);
            } catch (e) {
                (0, (0, parcelRequire("cala7")).Logger).errorWithOperationalEvent({
                    action: 'usedAtlBrowserStorageSetItemError',
                    message: `${storageType} failed to setItem. ${e.message || ''}`,
                    attributes: {
                        outsidePackage: false,
                        storageType: storageType
                    }
                });
            }
            try {
                (0, (0, parcelRequire("aGNyr")).sendPackageOperationalEvent)({
                    action: 'usedAtlBrowserStorageSetItem',
                    attributes: {
                        itemKey: originalItemKey,
                        outsidePackage: !itemSetByPackage,
                        storageType: storageType
                    }
                });
                try {
                    (0, (0, parcelRequire("4o4nv")).isProcessingAllowedByPreferences)({
                        itemKey: originalItemKey,
                        allowedCallback: ()=>{
                            originalSetItem.apply(storageContext, [
                                originalItemKey,
                                originalItemValue
                            ]);
                        },
                        blockedCallback: ({ itemHasCategory: itemHasCategory })=>{
                            if ((0, (0, parcelRequire("VSDnB")).fg)('platform.moonjelly.block-unknown-cookies')) return;
                            else if (!itemHasCategory) originalSetItem.apply(storageContext, [
                                originalItemKey,
                                originalItemValue
                            ]);
                        },
                        cachedKeysDataProperty: storageType === (0, (0, parcelRequire("d7IKg")).StorageType).LocalStorage ? (0, (0, parcelRequire("iG1qD")).CachedKeysDataProperty).LocalStorage : (0, (0, parcelRequire("iG1qD")).CachedKeysDataProperty).SessionStorage
                    });
                } catch (e) {
                    (0, (0, parcelRequire("cala7")).Logger).errorWithOperationalEvent({
                        action: 'usedAtlBrowserStorageSetItemError',
                        message: `Failed to set item. ${e.message || ''}`,
                        attributes: {
                            itemKey: originalItemKey,
                            storageType: storageType
                        }
                    });
                }
            } catch (e) {
                (0, (0, parcelRequire("cala7")).Logger).errorWithOperationalEvent({
                    action: 'usedAtlBrowserStorageSetItemError',
                    message: `Failed to send ${storageType} setter event. ${e.message || ''}`
                });
            }
        };
});
